//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.Tables.js";
import "../no/Diagramming.js";
SPLM.Diagramming.Tables.SizedSymbol = class{
    constructor(paddingFromLastSymbol,symbol,height,width){
        this.paddingFromLastSymbol=paddingFromLastSymbol;this.symbol=symbol;this.height=height;this.width=width;}
    get Paddingfromlastsymbol(){return this.paddingFromLastSymbol}
    set Paddingfromlastsymbol(val){this.paddingFromLastSymbol = val}
    get Symbol(){return this.symbol}
    set Symbol(val){this.symbol = val}
    get Height(){return this.height}
    set Height(val){this.height = val}
    get Width(){return this.width}
    set Width(val){this.width = val}
};

SPLM.Diagramming.Tables.AnchorLocation = Object.freeze({
    "TopLeft" : "TopLeft", "TopRight" : "TopRight", "BottomLeft" : "BottomLeft", "BottomRight" : "BottomRight"});

SPLM.Diagramming.Tables.HeaderLocation = Object.freeze({
    "Start" : "Start", "End" : "End"});

SPLM.Diagramming.Tables.HeaderOrientation = Object.freeze({
    "Vertical" : "Vertical", "Horizontal" : "Horizontal"});

SPLM.Diagramming.Tables.ContentAlignment = Object.freeze({
    "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "MiddleLeft" : "MiddleLeft", "MiddleCenter" : "MiddleCenter", "MiddleRight" : "MiddleRight", "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

SPLM.Diagramming.Tables.OverflowBehavior = Object.freeze({
    "Wrap" : "Wrap", "Truncate" : "Truncate", "OverflowBorder" : "OverflowBorder", "ShrinkToFit" : "ShrinkToFit", "Suffix" : "Suffix"});

SPLM.Diagramming.Tables.ZeroDisplay = Object.freeze({
    "Zero" : "Zero", "Dash" : "Dash", "Empty" : "Empty"});

SPLM.Diagramming.Tables.SizingMethod = Object.freeze({
    "Auto" : "Auto", "Fixed" : "Fixed"});

SPLM.Diagramming.Tables.ContinuationLocation = Object.freeze({
    "Up" : "Up", "Down" : "Down", "Left" : "Left", "Right" : "Right", "NextSheet" : "NextSheet"});

SPLM.Diagramming.Tables.TextDirection = Object.freeze({
    "Horizontal" : "Horizontal", "VerticalRightReading" : "VerticalRightReading", "VerticalLeftReading" : "VerticalLeftReading"});

export default SPLM;